/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _modules_init__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var _modules_popups__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(3);
/* harmony import */ var _modules_forms__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5);
/* harmony import */ var _modules_burgerMenu__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(7);
/* harmony import */ var _modules_share__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8);
/* harmony import */ var _modules_scrollNav__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(9);
/* harmony import */ var _modules_upload__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4);
/* harmony import */ var _modules_headerSticky__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11);
/* harmony import */ var _modules_voting__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(12);










 //import photoReport from './modules/photoReport';

var photoReport = function photoReport() {
  $('.js-report-photo').magnificPopup({
    delegate: 'a',
    type: 'image',
    mainClass: 'mfp-no-margins mfp-with-zoom',
    gallery: {
      enabled: true,
      preload: [1, 2],
      navigateByImgClick: false,
      tPrev: '',
      tNext: '',
      tCounter: '%curr%/%total%'
    },
    zoom: {
      enabled: false,
      duration: 300
    }
  });
};

$(function () {
  Object(_modules_init__WEBPACK_IMPORTED_MODULE_0__["default"])();
  Object(_modules_popups__WEBPACK_IMPORTED_MODULE_1__["bindPopups"])();
  Object(_modules_forms__WEBPACK_IMPORTED_MODULE_2__["default"])();
  Object(_modules_upload__WEBPACK_IMPORTED_MODULE_6__["uploadPhoto"])();
  Object(_modules_upload__WEBPACK_IMPORTED_MODULE_6__["uploadFile"])();
  Object(_modules_burgerMenu__WEBPACK_IMPORTED_MODULE_3__["default"])();
  Object(_modules_share__WEBPACK_IMPORTED_MODULE_4__["default"])();
  Object(_modules_scrollNav__WEBPACK_IMPORTED_MODULE_5__["default"])();
  Object(_modules_headerSticky__WEBPACK_IMPORTED_MODULE_7__["default"])();
  Object(_modules_voting__WEBPACK_IMPORTED_MODULE_8__["default"])();
  photoReport();
});

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);


var init = function init() {
  $.ajaxSetup({
    beforeSend: function beforeSend(xhr, settings) {
      // these HTTP methods do not require CSRF protection
      if (!/^(GET|HEAD|OPTIONS|TRACE)$/.test(settings.type) && !this.crossDomain) {
        xhr.setRequestHeader("X-CSRFToken", _global__WEBPACK_IMPORTED_MODULE_0__["csrftoken"]);
      }
    }
  });
  $.applyDataMask();
};

/* harmony default export */ __webpack_exports__["default"] = (init);

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "classes", function() { return classes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectors", function() { return selectors; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "jQueryObjects", function() { return jQueryObjects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "csrftoken", function() { return csrftoken; });
var classes = {
  activeClass: 'active',
  inActiveClass: 'inactive',
  showClass: 'show',
  hideClass: 'hide',
  errorClass: 'error',
  bodyClass: 'body',
  hiddenClass: 'hidden'
};
var selectors = {
  btnSelector: '.btn',
  btnCrossSelector: '.js-btn-close',
  btnVoteSelector: '.js-btn-vote',
  loaderSelector: '.loader',
  formNomineeSelector: '.js-form-add-nominee',
  regularError: '.js-regular-error',
  criticalError: '.js-critical-error',
  menuSelector: '.menu-mobile',
  completeMessage: '.complete-message',
  imgPreviewSelector: '.js-img-preview',
  filePreviewSelector: '.js-file-preview',
  questLinkSelector: '.js-questionnaire-link'
};
var jQueryObjects = {
  document: $(document),
  menu: $(selectors.menuSelector)
};
var csrftoken = Cookies.get('csrftoken');


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bindPopups", function() { return bindPopups; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showPopup", function() { return showPopup; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hidePopup", function() { return hidePopup; });
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);
/* harmony import */ var _upload__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(4);


var bodyClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].bodyClass,
    inActiveClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].inActiveClass,
    body = $(bodyClass);

function showPopup(popup) {
  popup.fadeIn();
  body.addClass(inActiveClass);
}

function hidePopup(popup, callback) {
  popup.fadeOut(function () {
    body.removeClass(inActiveClass);

    if (typeof callback === 'function') {
      callback();
    }
  });
}

;

var bindPopups = function bindPopups() {
  var showClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].showClass,
      document = _global__WEBPACK_IMPORTED_MODULE_0__["jQueryObjects"].document,
      menu = _global__WEBPACK_IMPORTED_MODULE_0__["jQueryObjects"].menu,
      btnCrossSelector = _global__WEBPACK_IMPORTED_MODULE_0__["selectors"].btnCrossSelector,
      formNomineeSelector = _global__WEBPACK_IMPORTED_MODULE_0__["selectors"].formNomineeSelector,
      completeMessage = _global__WEBPACK_IMPORTED_MODULE_0__["selectors"].completeMessage,
      imgPreviewSelector = _global__WEBPACK_IMPORTED_MODULE_0__["selectors"].imgPreviewSelector,
      menuSelector = _global__WEBPACK_IMPORTED_MODULE_0__["selectors"].menuSelector,
      questLinkSelector = _global__WEBPACK_IMPORTED_MODULE_0__["selectors"].questLinkSelector;

  function bindPopup(trigger, popupSelector) {
    var popup = $(popupSelector),
        btnCloseSelector = "".concat(popupSelector, " ").concat(btnCrossSelector);

    function bindShowHandler(trigger) {
      document.on('click', trigger, function (e) {
        e.preventDefault();

        var _this = $(this);

        if (menu.hasClass(showClass)) {
          $("".concat(menuSelector, " ").concat(btnCrossSelector)).click();
        }

        if (_this.hasClass('js-btn-add-nominee')) {
          popup.find(formNomineeSelector).attr('action', _this.data('action'));

          if (_this.data('questionnaire')) {
            popup.find(questLinkSelector).attr('href', _this.data('questionnaire')).show();
            popup.find('input[name="completed_form"]').closest('.form__item').show();
          } else {
            popup.find(questLinkSelector).attr('href', '').hide();
            popup.find('input[name="completed_form"]').closest('.form__item').hide();
          }
        } else if (_this.hasClass('js-btn-login')) {
          var nextUrl = _this.data('next-url');

          if (nextUrl) {
            popup.find('.social-auth__item').each(function (i, el) {
              var _el = $(el);

              _el.data('orig-href', _el.attr('href')).attr('href', "".concat(_el.attr('href'), "?next=").concat(encodeURIComponent(nextUrl), "&"));
            });
          }
        }

        showPopup(popup);
      });
    }

    function bindHideHandler() {
      document.on('click', btnCloseSelector, function () {
        hidePopup(popup, function () {
          if (popup.hasClass('popup-add-nominee')) {
            popup.find(completeMessage).hide();
            var form = popup.find(formNomineeSelector);
            form.show();
            form[0].reset();
            Object(_upload__WEBPACK_IMPORTED_MODULE_1__["resetPhotoInput"])(form.find(imgPreviewSelector)); // resetFileInput(form.find(filePreviewSelector));
          } else if (popup.hasClass('popup-login')) {
            popup.find('.social-auth__item').each(function (i, el) {
              var _el = $(el),
                  origHref = _el.data('orig-href');

              if (origHref) {
                _el.attr('href', origHref).removeData('orig-href');
              }
            });
          }
        });
      });
    }

    ;

    if (trigger) {
      bindShowHandler(trigger);
    }

    bindHideHandler();
  }

  ;
  bindPopup('.js-btn-add-nominee', '.popup-add-nominee');
  bindPopup('.js-btn-login', '.popup-login');
  bindPopup('', '.popup-notification-vote');

  if (window.AWARD.open_popup == 'already_voted') {
    showPopup($('.popup-notification-vote'));
  }
};



/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetPhotoInput", function() { return resetPhotoInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "resetFileInput", function() { return resetFileInput; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadPhoto", function() { return uploadPhoto; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "uploadFile", function() { return uploadFile; });
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);

var formNomineeSelector = _global__WEBPACK_IMPORTED_MODULE_0__["selectors"].formNomineeSelector,
    imgPreviewSelector = _global__WEBPACK_IMPORTED_MODULE_0__["selectors"].imgPreviewSelector,
    filePreviewSelector = _global__WEBPACK_IMPORTED_MODULE_0__["selectors"].filePreviewSelector,
    document = _global__WEBPACK_IMPORTED_MODULE_0__["jQueryObjects"].document,
    showClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].showClass,
    formNominee = $(formNomineeSelector),
    uploadFileSelector = '.upload-file',
    imgNomineeSelector = '.js-img-nominee',
    fileNomineeSelector = '.js-file-nominee',
    labelSelector = 'label',
    imgSelector = 'img',
    spanSelector = 'span';

function resetPhotoInput(target) {
  target.closest(uploadFileSelector).find(imgNomineeSelector).val('');
  target.closest(uploadFileSelector).find(labelSelector).show();
  target.hide().find(imgSelector).attr('src', '');
}

function resetFileInput(target) {
  target.closest(uploadFileSelector).find(fileNomineeSelector).val('');
  target.closest(uploadFileSelector).find(labelSelector).show();
  target.removeClass(showClass).find(spanSelector).text('');
}

var uploadPhoto = function uploadPhoto() {
  function onChangeInput() {
    document.on('change', imgNomineeSelector, function () {
      var _this = $(this),
          _file = this.files[0];

      if (this.files && _file) {
        var reader = new FileReader();

        reader.onload = function (e) {
          _this.closest(uploadFileSelector).find(imgPreviewSelector).show().find(imgSelector).attr('src', e.target.result);
        };

        if (!_file.type.match('image/*')) {
          _this.val('');

          alert('Изображение должно быть в формате png или jpg');
        } else if (_file.size > 15728640) {
          _this.val('');

          alert('Размер файла не должен превышать 15 МБ');
        } else {
          _this.closest(labelSelector).hide();

          reader.readAsDataURL(_file);
        }
      }
    });
  }

  ;

  function onClickPreview() {
    formNominee.on('click', imgPreviewSelector, function () {
      resetPhotoInput($(this));
    });
  }

  ;
  onChangeInput();
  onClickPreview();
};

var uploadFile = function uploadFile() {
  function onChangeInput() {
    document.on('change', fileNomineeSelector, function () {
      var _this = $(this),
          _file = this.files[0];

      if (this.files && _file) {
        var name = _file.name;

        if (_file.size > 15728640) {
          _this.val('');

          alert('Размер файла не должен превышать 15 МБ');
        } else {// _this.closest(labelSelector).hide();
          // _this
          //   .closest(uploadFileSelector)
          //   .find(filePreviewSelector)
          //   .addClass(showClass)
          //   .find(spanSelector)
          //   .text(name);
        }
      }
    });
  }

  ;

  function onClickPreview() {
    formNominee.on('click', filePreviewSelector, function () {// resetFileInput($(this));
    });
  }

  ;
  onChangeInput();
  onClickPreview();
};



/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _formsValidation__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(6);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);



var forms = function forms() {
  var showClass = _global__WEBPACK_IMPORTED_MODULE_1__["classes"].showClass,
      btnSelector = _global__WEBPACK_IMPORTED_MODULE_1__["selectors"].btnSelector,
      loaderSelector = _global__WEBPACK_IMPORTED_MODULE_1__["selectors"].loaderSelector,
      formNomineeSelector = _global__WEBPACK_IMPORTED_MODULE_1__["selectors"].formNomineeSelector,
      regularError = _global__WEBPACK_IMPORTED_MODULE_1__["selectors"].regularError,
      criticalError = _global__WEBPACK_IMPORTED_MODULE_1__["selectors"].criticalError,
      completeMessage = _global__WEBPACK_IMPORTED_MODULE_1__["selectors"].completeMessage,
      document = _global__WEBPACK_IMPORTED_MODULE_1__["jQueryObjects"].document;

  function ajaxSubmission(formHtml, completeCallback) {
    var validationFunc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var grecaptchaAction = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    var form = $(formHtml),
        btn = form.find(btnSelector),
        loader = form.find(loaderSelector);

    if (typeof validationFunc !== 'function' || validationFunc(form)) {
      var ajax_call = function ajax_call() {
        $.ajax({
          type: form.attr('method'),
          url: form.attr('action'),
          data: formData,
          contentType: false,
          processData: false,
          dataType: 'json',
          complete: function complete(jqXHR) {
            completeCallback(jqXHR.responseJSON, form, loader, btn);
          }
        });
      };

      btn.hide();
      loader.addClass(showClass);
      var formData = new FormData(form.get(0));

      if (grecaptchaAction.length > 0) {
        grecaptcha.ready(function () {
          grecaptcha.execute(window.AWARD.rpkv3, {
            action: grecaptchaAction
          }).then(function (token) {
            formData.set('captcha', token || '-');
            ajax_call();
          });
        });
      } else {
        ajax_call();
      }
    }
  }

  function onSubmitSuggestForm() {
    document.on('submit', formNomineeSelector, function (e) {
      e.preventDefault();

      var callback = function callback(resp, form, loader, btn) {
        var critical = true;

        if (resp) {
          if (resp.result == 'valid') {
            critical = false;
            form.parent().find(completeMessage).show();
            form.hide();
          } else if (resp.result == 'invalid') {
            critical = false;

            var _loop = function _loop(name) {
              var msgs = [];
              var target = null;
              resp.errors[name].forEach(function (error) {
                msgs.push(error.message);
              });

              if (name == '__all__' || name == 'captcha') {
                target = form.find(regularError);
              } else {
                target = form.find("[name=".concat(name, "]"));
              }

              if (msgs.length > 0) {
                _formsValidation__WEBPACK_IMPORTED_MODULE_0__["showErrorMsg"](target, msgs.join('<br>'));
              }
            };

            for (var name in resp.errors) {
              _loop(name);
            }
          }
        }

        if (critical) {
          loader.removeClass(showClass);
          form.find(criticalError).show();
        } else {
          btn.show();
          loader.removeClass(showClass);
        }
      };

      ajaxSubmission(e.target, callback, _formsValidation__WEBPACK_IMPORTED_MODULE_0__["checkAddNomineeForm"], 'add_nominee');
    });
  }

  ;
  onSubmitSuggestForm();
};

/* harmony default export */ __webpack_exports__["default"] = (forms);

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showErrorMsg", function() { return showErrorMsg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hideErrorMsg", function() { return hideErrorMsg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkAddNomineeForm", function() { return checkAddNomineeForm; });
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);

var errorClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].errorClass,
    regularError = _global__WEBPACK_IMPORTED_MODULE_0__["selectors"].regularError,
    questLinkSelector = _global__WEBPACK_IMPORTED_MODULE_0__["selectors"].questLinkSelector,
    formItemClass = 'form__item',
    formItemSelector = '.' + formItemClass,
    spanSelector = 'span',
    regExpMail = new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);
var errorMessage = {
  empty: 'Обязательное поле',
  email: 'Некорректный email',
  phone: 'Некорректный номер',
  rulesAgree: 'Подтвердите, что вы ознакомлены с условиями',
  captcha: 'Подтвердите, что вы не робот'
};

function showErrorMsg(target, text) {
  var tmp = "<span>".concat(text, "</span>");
  var parent = null;

  if (target.hasClass(formItemClass)) {
    parent = target;
  } else {
    parent = target.closest(formItemSelector);
  }

  parent.addClass(errorClass);
  parent.find(spanSelector).remove();
  parent.append(tmp);
}

;

function hideErrorMsg(target) {
  var parent = target.closest(formItemSelector);
  parent.removeClass(errorClass);
  parent.find(spanSelector).remove();
}

;

function checkAddNomineeForm(form) {
  var completedForm = form.find('input[name="completed_form"]'),
      completedFormValue = completedForm.val(),
      questLink = form.find(questLinkSelector),
      fullName = form.find('input[name="full_name"]'),
      fullNameValue = fullName.val().trim(),
      company = form.find('input[name="company"]'),
      companyValue = company.val().trim(),
      contactFullName = form.find('input[name="contact_full_name"]'),
      contactFullNameValue = contactFullName.val().trim(),
      contactPhone = form.find('input[name="contact_phone"]'),
      contactPhoneValue = contactPhone.val().trim(),
      contactEmail = form.find('input[name="contact_email"]'),
      contactEmailValue = contactEmail.val().trim(),
      rules = form.find('input[name="rules-agree"]'),
      rulesValue = rules.prop('checked');
  var completedFormError = true,
      fullNameError = true,
      companyError = true,
      contactFullNameError = true,
      contactPhoneError = true,
      contactEmailError = true,
      rulesError = true;

  if (completedFormValue === '' && questLink.attr('href') !== '') {
    showErrorMsg(completedForm, errorMessage.empty);
  } else {
    hideErrorMsg(completedForm);
    completedFormError = false;
  }

  if (fullNameValue === '') {
    showErrorMsg(fullName, errorMessage.empty);
  } else {
    hideErrorMsg(fullName);
    fullNameError = false;
  }

  if (companyValue === '') {
    showErrorMsg(company, errorMessage.empty);
  } else {
    hideErrorMsg(company);
    companyError = false;
  }

  if (contactFullNameValue === '') {
    showErrorMsg(contactFullName, errorMessage.empty);
  } else {
    hideErrorMsg(contactFullName);
    contactFullNameError = false;
  }

  if (contactPhoneValue === '') {
    showErrorMsg(contactPhone, errorMessage.empty);
  } else if (contactPhoneValue.length < 12) {
    showErrorMsg(contactPhone, errorMessage.phone);
  } else {
    hideErrorMsg(contactPhone);
    contactPhoneError = false;
  }

  if (contactEmailValue === '') {
    showErrorMsg(contactEmail, errorMessage.empty);
  } else if (!regExpMail.test(contactEmailValue)) {
    showErrorMsg(contactEmail, errorMessage.email);
  } else {
    hideErrorMsg(contactEmail);
    contactEmailError = false;
  }

  if (!rulesValue) {
    showErrorMsg(rules, errorMessage.rulesAgree);
  } else {
    hideErrorMsg(rules);
    rulesError = false;
  }

  hideErrorMsg(form.find(regularError));

  if (completedFormError || fullNameError || companyError || contactFullNameError || contactPhoneError || contactEmailError || rulesError) {
    return false;
  } else {
    return true;
  }
}

;


/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);


var burgerMenu = function burgerMenu() {
  var btnMenu = $('.js-btn-menu'),
      menuSelector = _global__WEBPACK_IMPORTED_MODULE_0__["selectors"].menuSelector,
      menu = $(menuSelector),
      showClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].showClass,
      btnClose = menu.find(_global__WEBPACK_IMPORTED_MODULE_0__["selectors"].btnCrossSelector);

  function showMenu() {
    btnMenu.on('click', function () {
      menu.addClass(showClass);
    });
  }

  ;

  function hideMenu() {
    btnClose.on('click', function () {
      menu.removeClass(showClass);
    });
  }

  ;
  showMenu();
  hideMenu();
};

/* harmony default export */ __webpack_exports__["default"] = (burgerMenu);

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);


var share = function share() {
  var shareSelector = '.share',
      socialListSelector = '.social-list',
      socialList = $("".concat(shareSelector, " ").concat(socialListSelector)),
      btnShareSelector = '.js-btn-share';

  function initSocialLikes() {
    socialList.socialLikes({
      counters: false
    });
  }

  ;

  function bindShare() {
    var document = _global__WEBPACK_IMPORTED_MODULE_0__["jQueryObjects"].document,
        activeClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].activeClass,
        showClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].showClass;
    document.on('click', btnShareSelector, function () {
      var _this = $(this),
          _parent = _this.parent(),
          _socialList = _parent.find(socialListSelector);

      _this.toggleClass(activeClass);

      _socialList.toggleClass(showClass);
    });

    function hideByTime(time) {
      document.on('mouseleave', shareSelector, function () {
        var _this = $(this),
            _btnShare = _this.find(btnShareSelector),
            _socialList = _this.find(socialListSelector),
            isShowClass = _socialList.hasClass(showClass);

        if (isShowClass) {
          this.resetState = setTimeout(function () {
            _btnShare.removeClass(activeClass);

            _socialList.removeClass(showClass);
          }, time);
        }
      });
      document.on('mouseenter', shareSelector, function () {
        var _this = $(this),
            isShowClass = _this.find(socialListSelector).hasClass(showClass);

        if (isShowClass) {
          clearTimeout(this.resetState);
        }
      });
    }

    ;
    hideByTime(4000);
  }

  ;
  bindShare();
  initSocialLikes();
};

/* harmony default export */ __webpack_exports__["default"] = (share);

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _modules__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);



var scrollNav = function scrollNav() {
  var document = _global__WEBPACK_IMPORTED_MODULE_1__["jQueryObjects"].document,
      menu = _global__WEBPACK_IMPORTED_MODULE_1__["jQueryObjects"].menu,
      showClass = _global__WEBPACK_IMPORTED_MODULE_1__["classes"].showClass,
      btnCrossSelector = _global__WEBPACK_IMPORTED_MODULE_1__["selectors"].btnCrossSelector,
      menuSelector = _global__WEBPACK_IMPORTED_MODULE_1__["selectors"].menuSelector,
      nominationsItemSelector = '.js-nominations-item',
      nominationSelector = '.nomination',
      dataNomination = 'data-nomination',
      navItemSelector = '.js-nav-link',
      sectionSelector = '.section',
      btnDownSelector = '.js-btn-down',
      dataNav = 'data-nav';

  function onClickItem(trigger, dataAttr, elemSelector) {
    var offset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    document.on('click', trigger, function (e) {
      e.preventDefault();

      var _this = $(this),
          id = _this.attr(dataAttr),
          _elem = $("".concat(elemSelector, "[").concat(dataAttr, "='").concat(id, "']"));

      if (menu.hasClass(showClass)) {
        $("".concat(menuSelector, " ").concat(btnCrossSelector)).click();
      }

      Object(_modules__WEBPACK_IMPORTED_MODULE_0__["scrollTo"])(_elem, offset);
    });
  }

  ;
  Object(_modules__WEBPACK_IMPORTED_MODULE_0__["setAttr"])(nominationsItemSelector, dataNomination);
  Object(_modules__WEBPACK_IMPORTED_MODULE_0__["setAttr"])(nominationSelector, dataNomination);
  onClickItem(nominationsItemSelector, dataNomination, nominationSelector, 60);
  onClickItem(navItemSelector, dataNav, sectionSelector, 60);
  onClickItem(btnDownSelector, dataNav, sectionSelector);

  if (window.AWARD.scroll_to && $(window.AWARD.scroll_to).length == 1) {
    Object(_modules__WEBPACK_IMPORTED_MODULE_0__["scrollTo"])(window.AWARD.scroll_to, 280);
  }
};

/* harmony default export */ __webpack_exports__["default"] = (scrollNav);

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setAttr", function() { return setAttr; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scrollTo", function() { return scrollTo; });
function setAttr(elemSelector, attr) {
  var count = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var elem = $(elemSelector);
  elem.each(function (i, it) {
    $(it).attr(attr, i + count);
  });
}

;

function scrollTo(elemSelector, offset) {
  var elem = $(elemSelector);
  $('html, body').animate({
    scrollTop: elem.offset().top - offset
  }, 'slow');
}

;


/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);


var headerSticky = function headerSticky() {
  var showClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].showClass;

  function showheaderOnScroll() {
    function show() {
      var headerSelector = '.js-header',
          header = $(headerSelector),
          offsetTop = $('.screen-main').outerHeight();
      var scrollTop = $(window).scrollTop();

      if (scrollTop > offsetTop) {
        header.addClass(showClass);
      } else {
        header.removeClass(showClass);
      }
    }

    ;
    show();
    $(window).on('scroll', show);
  }

  ;
  showheaderOnScroll();
};

/* harmony default export */ __webpack_exports__["default"] = (headerSticky);

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _global__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2);


var voting = function voting() {
  var document = _global__WEBPACK_IMPORTED_MODULE_0__["jQueryObjects"].document,
      btnVoteSelector = _global__WEBPACK_IMPORTED_MODULE_0__["selectors"].btnVoteSelector,
      loaderSelector = _global__WEBPACK_IMPORTED_MODULE_0__["selectors"].loaderSelector,
      criticalError = _global__WEBPACK_IMPORTED_MODULE_0__["selectors"].criticalError,
      showClass = _global__WEBPACK_IMPORTED_MODULE_0__["classes"].showClass;

  function animationProgressBar() {
    $('.result__bar-progress').each(function (i, item) {
      var _this = $(item),
          width = '' + _this.data('progress') + '%',
          displayVotes = _this.closest('.result').find('.js-display-votes');

      _this.css('width', 0).stop().animate({
        width: width
      }, 1400);

      animationPercent(displayVotes, 1400);
    });
  }

  ;

  function animationPercent(elem, duration) {
    var start = 0,
        current = start,
        end = parseFloat(elem.text()),
        range = end - start,
        increment = end > start ? 1 : 0,
        step = Math.abs(Math.floor(duration / range));
    var timer = setInterval(function () {
      current += increment;
      elem.text(current);

      if (current === end) {
        clearInterval(timer);
      }
    }, step);
  }

  ;

  function onClickBtnVote() {
    document.on('click', btnVoteSelector, function (e) {
      e.preventDefault();

      var _this = $(this),
          partWrapper = _this.closest('.nominees__item'),
          nomButtons = _this.closest('.nominees').find(btnVoteSelector),
          loader = partWrapper.find(loaderSelector);

      nomButtons.prop('disabled', true);

      _this.hide();

      loader.addClass(showClass);
      $.ajax({
        type: 'POST',
        url: _this.data('url'),
        dataType: 'json',
        complete: function complete(jqXHR) {
          var resp = jqXHR.responseJSON;
          loader.removeClass(showClass);

          if (resp && resp.result == 'success') {
            _this.find('span').text('голос принят!');

            _this.find('.js-choice-message').show();

            _this.show();

            nomButtons.not(_this).find('.js-other-message').show();
            resp.participants.forEach(function (part) {
              var _part = $('#part-' + part.id);

              _part.find('.js-display-votes').text(part.votes_percent);

              _part.find('.js-progress-votes').data('progress', part.votes_percent).attr('data-progress', part.votes_percent);
            });
            animationProgressBar();
          } else {
            partWrapper.find(criticalError).show();
          }
        }
      });
    });
  }

  ;
  onClickBtnVote();
  animationProgressBar();
};

/* harmony default export */ __webpack_exports__["default"] = (voting);

/***/ })
/******/ ]);